export const EDIT_USER_DRAWER = 'EDIT_USER_DRAWER';
export const SUBSCRIBER_DRAWER = 'SUBSCRIBER_DRAWER';
export const ADD_USER_DRAWER = 'ADD_USER_DRAWER';
export const EDIT_PRODUCT_DRAWER = 'EDIT_PRODUCT_DRAWER';
export const EMAIL_IS_VALID = 'IS_VALID';
export const EMAIL_IS_NOT_VALID = 'IS_NOT_VALID';
export const EDIT_GUEST_USER_DRAWER = 'EDIT_GUEST_USER_DRAWER';

export const regexPhone = /^(\+{1})?([0-9]{1,3}-)*(([0-9]-)*)*[0-9]*$/;
export const regexExt = /^[0-9]{1,6}$/;

export default ADD_USER_DRAWER;

export const FIRST_NAME_PATH = ['userDetails', 'firstName'];
export const LAST_NAME_PATH = ['userDetails', 'lastName'];
export const EMAIL_PATH = ['userDetails', 'email'];
export const CONTACT_EMAIL_PATH = ['userDetails', 'contactInfo', 'contactEmail'];
export const HTTP_STATUS_OK = 200;
